import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import _styled from '@emotion/styled/base';
import { Box } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import isStyledPropsValid from '../utils/isStyledPropsValid.js';
const StyledDialog = /*#__PURE__*/_styled(Dialog, {
  shouldForwardProp: isStyledPropsValid,
  target: "e13x1kru6"
})(_ref => {
  let {
    theme,
    maxWidth,
    sx = {}
  } = _ref;
  return {
    '& .MuiPaper-root': _objectSpread2({
      maxWidth: "".concat(maxWidth, " !important"),
      width: '100%',
      borderRadius: '4px',
      background: 'white',
      minHeight: '100px',
      position: 'relative'
    }, sx)
  };
}, "");
const StyledPopupHeader = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e13x1kru5"
})(_ref2 => {
  return {
    padding: '24px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    borderBottom: '1px solid #E6E6E6',
    backgroundColor: 'white'
  };
}, "");
const StyledPopupTitle = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e13x1kru4"
})(_ref3 => {
  return {
    fontSize: '20px',
    color: '#555',
    fontWeight: 700
  };
}, "");
const StyledPopupFooter = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e13x1kru3"
})(_ref4 => {
  return {
    padding: '16px 32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    boxShadow: '0px 4px 15px 0px rgba(0, 0, 0, 0.10)',
    backgroundColor: 'white'
  };
}, "");
const StyledPopupContent = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e13x1kru2"
})(_ref5 => {
  return {
    padding: '24px 32px'
  };
}, "");
const StyledPopupRightFooterWrapper = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e13x1kru1"
})(_ref6 => {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '12px'
  };
}, "");
const StyledThirdBtn = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e13x1kru0"
})(_ref7 => {
  return {
    color: '#7B61FF',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    textDecoration: 'underline',
    cursor: 'pointer'
  };
}, "");
export { StyledDialog, StyledPopupContent, StyledPopupFooter, StyledPopupHeader, StyledPopupRightFooterWrapper, StyledPopupTitle, StyledThirdBtn };